export default "__VITE_ASSET__CNxwd_XR__"